import service from "../service";
import { getApiBaseUrl } from "../config";

export default {
  // Manual

  async getOperationMode() {
    const response = await service.get(`${getApiBaseUrl()}monitor/mode`)
    return response;
  },

  async setOperationMode(args) {
    const response = await service.patch(
      `${getApiBaseUrl()}monitor/mode/${args}`
    );
    return response;
  },

  async actionSilo(feederId, siloId, args) {
    const response = await service.post(
      `${getApiBaseUrl()}feeder/${feederId}/silo/${siloId}`,
      args
    );
    return response;
  },
  async actionStart(id, setting) {
    const response = await service.get(
      `${getApiBaseUrl()}manual/start/${id}`,
      setting
    );
    return response;
  },

  async actionStop(id, setting) {
    const response = await service.get(
      `${getApiBaseUrl()}manual/stop/${id}`,
      setting
    );
    return response;
  },

  async actionAllSilo(feederId, args) {
    const response = await service.post(
      `${getApiBaseUrl()}feeder/${feederId}/silo/action`,
      args
    );
    return response;
  },

  async actionRotary(feederId, siloId, args) {
    const response = await service.post(
      `${getApiBaseUrl()}feeder/${feederId}/silo/${siloId}/rotary/action`,
      args
    );
    return response;
  },


  async setRotary(feederId, siloId, args) {
    const response = await service.post(
      `${getApiBaseUrl()}feeder/${feederId}/silo/${siloId}/rotary/setting`,
      args
    );
    return response;
  },

  async actionBlow(feederId, siloId, args) {
    const response = await service.post(
      `${getApiBaseUrl()}feeder/${feederId}/silo/${siloId}/blow`,
      args
    );
    return response;
  },
};
